import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUndoAlt, faAward } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import Translate, { translateDate, t, numStr } from '../common/Translate';
import MeetingTag from '../Calendar/MeetingTag';
import Timer from '../common/Timer';
import { currencySign } from '../../Utils/currencySign';

const RecordButton = ({ record, origin, currentTab }) => {
  const {
    refHexaId,
    brandName,
    modelName,
    mileage,
    recordId,
    registration,
    appointmentDate,
    appointmentTime,
    expertiseEndedAt,
    queries,
    hbs,
    buyerFullName,
    concessionName,
    recordTypeId,
    coverage,
    startTime,
    finishTime,
    rplCoverageRequest,
    carProfile,
    salesCreatedAt,
    salesEndedAt,
    bestSaleOfferAmount,
    currentWinner,
    countOffer,
    b2cMarketValue,
    sourceLabel,
    // originId,
  } = record;

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = (e) => {
    e.preventDefault();
    setTooltipOpen(!tooltipOpen);
  };

  const name = _.remove([brandName, modelName, numStr(mileage)], (v) => v && v !== 'NaN'); // remove empty values
  if (['supervisorAwaiting', 'supervisorOngoingAppraisal'].includes(currentTab))
    name[2] = translateDate(appointmentDate, 'YYYY');

  let formButtonContent = '';
  if (currentTab === 'supervisorCoverageRequest') {
    formButtonContent = (
      <>
        <div className="d-flex justify-content-between">
          <MeetingTag code={record.statusCarcheck} />
          <Timer salesEndedAt={salesEndedAt} />
        </div>
        {hbs && (
          <>
            <FontAwesomeIcon
              icon={faHome}
              size="1x"
              id={`tooltip-${recordId}`}
              className="hbs-icon ml-3"
              onClick={(e) => toggle(e)}
            />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={`tooltip-${recordId}`}
              toggle={() => {}}
              className="my-tooltip"
            >
              {t('hbsFile')}
            </Tooltip>
          </>
        )}
        {coverage && (
          <>
            <FontAwesomeIcon
              icon={faAward}
              size="1x"
              id={`tooltip-ford-${recordId}`}
              className="hbs-icon ml-3"
              onClick={(e) => toggle(e)}
            />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={`tooltip-ford-${recordId}`}
              toggle={() => {}}
              className="my-tooltip"
            >
              {t('guaranteedPriceLabel')}
            </Tooltip>
          </>
        )}
        {recordTypeId === 2 && (
          <>
            <FontAwesomeIcon
              icon={faUndoAlt}
              size="1x"
              id={`tooltip-${recordId}`}
              className="hbs-icon ml-3"
              onClick={(e) => toggle(e)}
            />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={`tooltip-${recordId}`}
              toggle={() => {}}
              className="my-tooltip"
            >
              {t('counterAppraisalFile')}
            </Tooltip>
          </>
        )}
        <div className="title" data-cy="inspectionName">
          {name.join(' - ')}
        </div>
        <div>
          <span className="font-weight-bold">
            <Translate code="file" />
            <Translate code=":" />
          </span>
          <span className="font-weight-light" data-cy="recordId">
            {refHexaId}
          </span>
          <>
            <span className="vertical-divider" />
            <span className="font-weight-bold">
              <Translate code="rplCoverageRequest" />
              <Translate code=":" />
            </span>
            <span className="font-weight-light">{rplCoverageRequest}</span>
            <span className="vertical-divider" />
            <span className="font-weight-bold">
              <Translate code="carProfile" />
              <Translate code=":" />
            </span>
            <span className="font-weight-light">{carProfile}</span>
            {salesCreatedAt && (
              <>
                <br />
                <span>
                  <small>
                    <Translate code="salesCreatedAt" />
                    <Translate code=":" />
                  </small>
                </span>
                <span className="font-weight-light" data-cy="recordId">
                  <small>{translateDate(salesCreatedAt, 'DD.MM.YYYY HH:MM')}</small>
                </span>
              </>
            )}
            <br />
            <span>
              <small className="font-weight-bold">
                <Translate code="countOffers" />
                <Translate code=":" />
              </small>
            </span>
            <span className="font-weight-light">{countOffer}</span>
            <span className="vertical-divider" />
            <span>
              <small className="font-weight-bold">
                <Translate code="bestSaleOfferAmount" />
                <Translate code=":" />
              </small>
            </span>
            <span className="font-weight-light">{bestSaleOfferAmount > 0 && numStr(bestSaleOfferAmount)}</span>
            <br />
            <span>
              <small className="font-weight-bold">
                <Translate code="currentWinner" />
                <Translate code=":" />
              </small>
            </span>
            <span className="font-weight-light">{currentWinner}</span>
          </>
        </div>
      </>
    );
  } else {
    formButtonContent = (
      <>
        <div className="d-flex justify-content-between">
          <MeetingTag code={!['supervisorAwaiting'].includes(currentTab) && record.statusCarcheck} />
          {['supervisorAwaiting', 'buyerAwaitingPricing'].includes(currentTab) && (
            <Timer
              expertiseEndedAt={_.get(expertiseEndedAt, 'date', null)}
              startTime={startTime}
              finishTime={finishTime}
            />
          )}
        </div>
        {hbs && (
          <>
            <FontAwesomeIcon
              icon={faHome}
              size="1x"
              id={`tooltip-${recordId}`}
              className="hbs-icon ml-3"
              onClick={(e) => toggle(e)}
            />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={`tooltip-${recordId}`}
              toggle={() => {}}
              className="my-tooltip"
            >
              {t('hbsFile')}
            </Tooltip>
          </>
        )}
        {coverage && (
          <>
            <FontAwesomeIcon
              icon={faAward}
              size="1x"
              id={`tooltip-ford-${recordId}`}
              className="hbs-icon ml-3"
              onClick={(e) => toggle(e)}
            />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={`tooltip-ford-${recordId}`}
              toggle={() => {}}
              className="my-tooltip"
            >
              {t('guaranteedPriceLabel')}
            </Tooltip>
          </>
        )}
        {recordTypeId === 2 && (
          <>
            <FontAwesomeIcon
              icon={faUndoAlt}
              size="1x"
              id={`tooltip-${recordId}`}
              className="hbs-icon ml-3"
              onClick={(e) => toggle(e)}
            />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={`tooltip-${recordId}`}
              toggle={() => {}}
              className="my-tooltip"
            >
              {t('counterAppraisalFile')}
            </Tooltip>
          </>
        )}
        <div className="title" data-cy="inspectionName">
          {name.join(' - ')}
        </div>
        <div>
          <span className="font-weight-bold">
            <Translate code="file" />
            <Translate code=":" />
          </span>
          <span className="font-weight-light" data-cy="recordId">
            {refHexaId}
          </span>
          {registration && registration !== '' && (
            <>
              <span className="vertical-divider" />
              <span className="font-weight-bold">
                <Translate code="plate" />
                <Translate code=":" />
              </span>
              <span className="font-weight-light" id="registrationFormButton" data-cy="registration">
                {registration}
              </span>
              {currentTab === 'supervisorAwaiting' && (
                <>
                  <br />
                  <span>
                    <small className="font-weight-bold">
                      <Translate code="b2cMarketValue" />
                      <Translate code=":" />
                    </small>
                    <span className="font-weight-light" data-cy="recordId">
                      {b2cMarketValue > 0 && currencySign(numStr(b2cMarketValue))}
                    </span>
                  </span>
                </>
              )}
              {appointmentDate && (
                <div>
                  <small className="font-weight-light text-sm">
                    {`${t('appointment_date')} ${translateDate(appointmentDate, 'DD.MM.YYYY')} ${appointmentTime}`}
                  </small>
                </div>
              )}
              {buyerFullName && (
                <>
                  <span>
                    <small className="font-weight-bold">
                      <Translate code="buyer" />
                      <Translate code=":" />
                    </small>
                  </span>
                  <span className="font-weight-light" data-cy="recordId">
                    <small>{buyerFullName}</small>
                  </span>
                </>
              )}
              {concessionName && (
                <>
                  <br />
                  <span>
                    <small className="font-weight-bold">
                      <Translate code="point_of_sale" />
                      <Translate code=":" />
                    </small>
                  </span>
                  <span className="font-weight-light" data-cy="recordId">
                    <small>{concessionName}</small>
                  </span>
                </>
              )}
              <br />
              <small className="font-weight-bold">
                <Translate code="source" />
                <Translate code=":" />
              </small>
              <span className="font-weight-light" data-cy="recordId">
                {sourceLabel}
              </span>
            </>
          )}
        </div>
        {/* {form.imageStatus < 100 ? <ImageUploadProgress form={form} /> : ""} */}
      </>
    );
  }
  return (
    <Link
      className="form-button"
      to={{
        pathname: `/files/${record.recordId}`,
        state: {
          origin,
          queries,
        },
      }}
      data-cy="formButton"
    >
      {formButtonContent}
    </Link>
  );
};

RecordButton.propTypes = {
  record: PropTypes.shape().isRequired,
  origin: PropTypes.string.isRequired,
  currentTab: PropTypes.string.isRequired,
};

export default RecordButton;
// const FormStatus = ({ status, localStatus }) => {
//   let content;
//   switch (status) {
//     case statusList.appointment_planned:
//       content = (
//         <span
//           className="badge badge-primary"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <img src={faCalendarAlt} alt="" className="mr-2" />
//           <Translate code="appointment_planned" />
//         </span>
//       );
//       break;
//     case statusList.expertise_restarted:
//     case statusList.expertise_started:
//       content = (
//         <span
//           className="badge badge-warning"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <img src={faCar} alt="" className="mr-2" />
//           <Translate code="ongoing_inspection" />
//         </span>
//       );
//       break;
//     case statusList.expertise_finished:
//       content = (
//         <span
//           className="badge badge-primary"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <img src={faHourglassHalf} alt="" className="mr-2" />
//           <Translate code="expertise_finished" />
//         </span>
//       );
//       break;
//     case statusList.expertise_authorized:
//     case statusList.auto_accept:
//       content = (
//         <span
//           className="badge badge-success"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <FontAwesomeIcon icon={faEuroSign} className="mr-2" size="1x" />
//           <Translate code="pricing_made" />
//         </span>
//       );
//       break;
//     case statusList.transaction:
//     case statusList.finish:
//       content = (
//         <span
//           className="badge badge-success"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <FontAwesomeIcon icon={faCheckDouble} className="mr-2" size="1x" />
//           <Translate code="ongoing_transaction" />
//         </span>
//       );
//       break;

//     case statusList.justified:
//     case statusList.repurchase_account:
//       content = (
//         <span
//           className="badge badge-danger"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <FontAwesomeIcon icon={faCheckDouble} className="mr-2" size="1x" />
//           <Translate code="purchased" />
//         </span>
//       );
//       break;

//     case statusList.supervisor_refused:
//     case statusList.refused:
//     case statusList.expertise_interrupted:
//     case statusList.not_show:
//     case statusList.come_left:
//     case statusList.report:
//     case statusList.outdated:
//     case statusList.appointment_canceled:
//       content = (
//         <span
//           className="badge badge-danger"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <FontAwesomeIcon icon={faStopCircle} className="mr-2" size="1x" />
//           <Translate code="outside_process" />
//         </span>
//       );
//       break;

//     case statusList.saved:
//       content = (
//         <span
//           className="badge badge-info"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <FontAwesomeIcon icon={faSave} className="mr-2" />
//           <Translate code="saved" />
//         </span>
//       );
//       break;
//     case statusList.completed:
//       if ([sending].includes(localStatus)) {
//         content = (
//           <span
//             className="badge badge-primary"
//             data-status={status}
//             data-cy="formBadge"
//           >
//             <Spinner
//               className="mr-2"
//               data-cy="formBadgeLs"
//               color="primary"
//               size="sm"
//             />
//             <Translate code="completed" />
//           </span>
//         );
//       } else if (
//         [error_network, to_send, error_post_form].includes(localStatus)
//       ) {
//         content = (
//           <span
//             className="badge badge-primary"
//             data-status={status}
//             data-cy="formBadge"
//           >
//             <Spinner className="mr-2" color="primary" size="sm" />
//             <Translate code="waiting_network" />
//           </span>
//         );
//       } else if ([updated].includes(localStatus)) {
//         content = (
//           <span
//             className="badge badge-primary"
//             data-status={status}
//             data-cy="formBadge"
//           >
//             <FontAwesomeIcon icon={faCheck} className="mr-2" />
//             <Translate code="waiting_submit" />
//           </span>
//         );
//       } else {
//         content = (
//           <span
//             className="badge badge-primary"
//             data-status={status}
//             data-cy="formBadge"
//           >
//             <FontAwesomeIcon icon={faCheck} className="mr-2" />
//             <Translate code="completed" />
//           </span>
//         );
//       }
//       break;
//     case statusList.submitted:
//       if ([sending].includes(localStatus)) {
//         content = (
//           <span
//             className="badge badge-primary"
//             data-status={status}
//             data-cy="formBadge"
//           >
//             <Spinner className="mr-2" color="primary" size="sm" />
//             <Translate code="submitted" />
//           </span>
//         );
//       } else if (
//         [error_network, to_send, error_post_form].includes(localStatus)
//       ) {
//         content = (
//           <span
//             className="badge badge-primary"
//             data-status={status}
//             data-cy="formBadge"
//           >
//             <Spinner className="mr-2" color="primary" size="sm" />
//             <Translate code="finalizing" />
//           </span>
//         );
//       } else {
//         content = (
//           <span
//             className="badge badge-success"
//             data-status={status}
//             data-cy="formBadge"
//           >
//             <FontAwesomeIcon icon={faCheckDouble} className="mr-2" />
//             <Translate code="submitted" />
//           </span>
//         );
//       }
//       break;
//     case statusList.report_available:
//       content = (
//         <span
//           className="badge badge-success"
//           data-status={status}
//           data-cy="formBadge"
//         >
//           <FontAwesomeIcon icon={faFilePdf} className="mr-2" />
//           <Translate code="report_available" />
//         </span>
//       );
//       break;
//     default:
//   }
//   return (
//     <div className="mb-2">
//       {content}
//       <span>
//         {localStatus === localStatusList.error_network && (
//           <img
//             src={noNetwork}
//             alt=""
//             className="mr-2 icon-no-network"
//             data-cy="formBadgeLs"
//             data-ls={localStatus}
//           />
//         )}
//         {localStatus === localStatusList.error_post_form && (
//           <FontAwesomeIcon
//             icon={faExclamationTriangle}
//             className="icon-error-post-form"
//             data-cy="formBadgeLs"
//             data-ls={localStatus}
//           />
//         )}
//       </span>
//     </div>
//   );
// };

// function ImageUploadProgress(props) {
//   let { imageStatus } = props.form;
//   if (imageStatus === 0) imageStatus = 10;
//   return (
//     <Progress animated className="progress-bar-images" color="success" value={imageStatus} data-cy="progressBarImages">
//       <Translate code="image_uploading" />
//     </Progress>
//   );
// }
